import { render, staticRenderFns } from "./CreditsTitleBrief.vue?vue&type=template&id=553dab12&scoped=true&"
import script from "./CreditsTitleBrief.vue?vue&type=script&lang=js&"
export * from "./CreditsTitleBrief.vue?vue&type=script&lang=js&"
import style0 from "./CreditsTitleBrief.vue?vue&type=style&index=0&id=553dab12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553dab12",
  null
  
)

export default component.exports